// extracted by mini-css-extract-plugin
export default {"detailsContent":"ProjectModal_detailsContent__h-9uc"};